import { components } from "@apiSchema";

export interface iReportProPublication {
    id: number;
    title: string;
    description: string;
    thumbnail: string;
    createdDate: string;
    numberOfPages: number;
    minutesToRead: number;
    hasAccess: boolean;
    isLiked: boolean;
    isAddedToReadingList: boolean;
    buttonCategoryId: number;
    titleCategoryId: number;
    publicationId: number;
    publicationTitle: string;
}

type iPublicationData = {
    subModel?: Partial<iReportProPublication>;
    apiModel?: components["schemas"]["ReportProPublicationClient"];
};

export class ReportProPublication implements iReportProPublication {
    id = ReportProPublication.defaultData.id;
    title = ReportProPublication.defaultData.title;
    description = ReportProPublication.defaultData.description;
    thumbnail = ReportProPublication.defaultData.thumbnail;
    createdDate = ReportProPublication.defaultData.createdDate;
    numberOfPages = ReportProPublication.defaultData.numberOfPages;
    minutesToRead = ReportProPublication.defaultData.minutesToRead;
    hasAccess = ReportProPublication.defaultData.hasAccess;
    isLiked = ReportProPublication.defaultData.isLiked;
    isAddedToReadingList = ReportProPublication.defaultData.isAddedToReadingList;
    buttonCategoryId = ReportProPublication.defaultData.buttonCategoryId;
    titleCategoryId = ReportProPublication.defaultData.titleCategoryId;
    publicationId = ReportProPublication.defaultData.publicationId;
    publicationTitle = ReportProPublication.defaultData.publicationTitle;

    static defaultData: iReportProPublication = {
        id: 0,
        title: '',
        description: '',
        thumbnail: '',
        createdDate: '',
        numberOfPages: 0,
        minutesToRead: 0,
        hasAccess: true,
        isLiked: false,
        isAddedToReadingList: false,
        buttonCategoryId: 0,
        titleCategoryId: 0,
        publicationId: 0,
        publicationTitle: '',
    };

    constructor(data?: iPublicationData) {
        if (data) {
            const { apiModel, subModel } = data;
            if (apiModel) {
                this.mapFromApi(apiModel);
            }
            else if (subModel) {
                this.mapFromClient(subModel);
            }
        }
    }

    private setData (model: iReportProPublication) {
        ({
            id: this.id,
            title: this.title,
            description: this.description,
            thumbnail: this.thumbnail,
            createdDate: this.createdDate,
            numberOfPages: this.numberOfPages,
            minutesToRead: this.minutesToRead,
            hasAccess: this.hasAccess,
            isLiked: this.isLiked,
            isAddedToReadingList: this.isAddedToReadingList,
            buttonCategoryId: this.buttonCategoryId,
            titleCategoryId: this.titleCategoryId,
            publicationId: this.publicationId,
            publicationTitle: this.publicationTitle,
        } = model);
    }

    private mapFromApi (apiModel: components["schemas"]["ReportProPublicationClient"]) {
        this.setData({
            id: apiModel.id ?? ReportProPublication.defaultData.id,
            title: apiModel.title ?? ReportProPublication.defaultData.title,
            description: apiModel.description ?? ReportProPublication.defaultData.description,
            thumbnail: apiModel.imageUrl ?? ReportProPublication.defaultData.thumbnail,
            createdDate: apiModel.createDate ?? ReportProPublication.defaultData.createdDate,
            numberOfPages: apiModel.numberOfPages ?? ReportProPublication.defaultData.numberOfPages,
            minutesToRead: apiModel.minutesToRead ?? ReportProPublication.defaultData.minutesToRead,
            hasAccess: apiModel.hasAccess ?? ReportProPublication.defaultData.hasAccess,
            isLiked: apiModel.isLiked ?? ReportProPublication.defaultData.isLiked,
            isAddedToReadingList: apiModel.isAddedToReadingList ?? ReportProPublication.defaultData.isAddedToReadingList,
            buttonCategoryId: apiModel.buttonCategoryId ?? ReportProPublication.defaultData.buttonCategoryId,
            titleCategoryId: apiModel.titleCategoryId ?? ReportProPublication.defaultData.titleCategoryId,
            publicationId: apiModel.publicationId ?? ReportProPublication.defaultData.publicationId,
            publicationTitle: apiModel.publicationTitle ?? ReportProPublication.defaultData.publicationTitle,
        });
    }

    private mapFromClient (clientModel: Partial<iReportProPublication>) {
        this.setData({
            ...ReportProPublication.defaultData,
            ...clientModel,
        });
    }
}